import YataiSelector from "./yatai-selector/YataiSelector";
import YataiSummary from "./yatai-summary/YataiSummary";

function Yatai() {
    return (
        <div>
            <YataiSelector/>
            <YataiSummary/>
        </div>
    );
}

export default Yatai;